import { useState } from "react";

const tabTitleBase =
    "w-full cursor-pointer border-b-[3px] border-[#eee] pb-2.5 text-center text-sm text-nt-grey transition-colors";
const tabTitleActive = "border-nt-red text-nt-blue";

const formationRow =
    "mb-0 flex max-md:mb-5 max-md:flex-col md:mb-0 [&:not(:last-child)]:max-md:mb-5";
const formationDateCol = "w-full shrink-0 text-nt-blue max-md:w-full md:w-1/5";
const formationBodyCol =
    "w-full text-justify md:w-4/5 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-nt-blue [&_h4]:text-sm [&_h4]:font-normal [&_h4]:text-nt-grey [&_p]:text-sm [&_p]:text-nt-grey";

const ProfileResume = ({ profile }) => {
    const [activeTab, setActiveTab] = useState(0);
    return (
        <div className="my-5 flex flex-col rounded-[10px] bg-white p-5">
            <div className="p-5">
                <ul className={`flex flex-col gap-4 text-nt-blue md:flex-row md:gap-0`}>
                    <li
                        onClick={() => setActiveTab(0)}
                        className={`${tabTitleBase} ${activeTab === 0 ? tabTitleActive : ""}`}
                    >
                        About Me
                    </li>
                    <li
                        onClick={() => setActiveTab(1)}
                        className={`${tabTitleBase} ${activeTab === 1 ? tabTitleActive : ""}`}
                    >
                        Education
                    </li>
                    <li
                        onClick={() => setActiveTab(2)}
                        className={`${tabTitleBase} ${activeTab === 2 ? tabTitleActive : ""}`}
                    >
                        Experience
                    </li>
                    <li
                        onClick={() => setActiveTab(3)}
                        className={`${tabTitleBase} ${activeTab === 3 ? tabTitleActive : ""}`}
                    >
                        Certificates
                    </li>
                </ul>

                <div className="pt-5 text-justify">
                    {activeTab === 0 && (
                        <div
                            className="[&_li]:font-light [&_ol]:ml-5 [&_ol]:list-decimal [&_ol_li]:font-light [&_p]:font-normal [&_ul]:ml-5 [&_ul]:list-disc [&_ul_li]:font-light"
                            dangerouslySetInnerHTML={{ __html: profile.description }}
                        />
                    )}
                    {activeTab === 1 && (
                        <div>
                            {!profile.noEducation &&
                                profile.education?.length &&
                                profile.education.map((formation, i) => {
                                    return (
                                        <div className={formationRow} key={i}>
                                            <div className={formationDateCol}>
                                                {formation.from} - {formation.toPresent ? " Present" : formation.to}
                                            </div>
                                            <div className={formationBodyCol}>
                                                <h3>{formation.label}</h3>
                                                <h4>{formation.school}</h4>
                                                <p>{formation.description}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            {profile.noEducation && <h4 className="text-nt-blue">No education level</h4>}
                        </div>
                    )}
                    {activeTab === 2 && (
                        <div>
                            {!profile.noExperience &&
                                profile.experience?.length &&
                                profile.experience.map((formation, i) => {
                                    return (
                                        <div className={formationRow} key={i}>
                                            <div className={formationDateCol}>
                                                {formation.from} - {formation.toPresent ? "Present" : formation.to}
                                            </div>
                                            <div className={formationBodyCol}>
                                                <h3>{formation.label}</h3>
                                                <h4>{formation.school}</h4>
                                                <p>{formation.description}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            {profile.noExperience && <h4 className="text-nt-blue">No work experience</h4>}
                        </div>
                    )}
                    {activeTab === 3 && (
                        <div>
                            {!profile.noCertificate &&
                                profile.certificate?.length &&
                                profile.certificate.map((formation, i) => {
                                    return (
                                        <div className={formationRow} key={i}>
                                            <div className={formationDateCol}>{formation.year}</div>
                                            <div className={formationBodyCol}>
                                                <h3>{formation.label}</h3>
                                                <p>{formation.description}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            {profile.noCertificate && <h4 className="text-nt-blue">No certificates</h4>}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
export { ProfileResume };
